import { render } from "./ConfirmClaim.vue?vue&type=template&id=2cdd2bd6&scoped=true"
import script from "./ConfirmClaim.vue?vue&type=script&lang=js"
export * from "./ConfirmClaim.vue?vue&type=script&lang=js"

import "./ConfirmClaim.vue?vue&type=style&index=0&id=2cdd2bd6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdd2bd6"]])

export default __exports__